import React from 'react';
import { App as MBApp } from '@mb/App';
import { IntlProvider } from '@mb/lib/i18n/CoordinatedIntlProvider';
import { Provider } from 'react-redux';
import { ThemeContainer } from 'ui-widgets';
import { AskProductModal } from './components/AskProductModal';
import { ContactRepModal } from './components/ContactRepModal';
import { store } from './redux/store';

export const App = () => {
  return (
    <IntlProvider>
      <MBApp>
        <ThemeContainer>
          <Provider store={store}>
            <AskProductModal />
            <ContactRepModal />
          </Provider>
        </ThemeContainer>
      </MBApp>
    </IntlProvider>
  );
};
